import { RoleType } from "@/constants/share";
import RSelect from "@/component/RSelect";
import ArrowDownIcon from "@/assets/common/ic_select_arrow_down.svg?react";
import ArrowUpIcon from "@/assets/common/ic_select_arrow_up.svg?react";

const permissionOptions = [
  {
    label: <div className="flex px-2 font-400 text-#191D26">创建人</div>,
    selectLabel: (
      <div className="flex px-0 font-400 text-mx-tertiary">创建人</div>
    ),
    value: RoleType.Creator,
    hide: true
  },
  {
    label: <div className="flex px-2 font-400 text-#191D26">可查看</div>,
    selectLabel: (
      <div className="flex px-0 font-400 text-mx-tertiary">可查看</div>
    ),
    value: RoleType.Viewer,
  },
  {
    label: <div className="flex px-2 font-400 text-#191D26">可管理</div>,
    selectLabel: <div className="flex font-400 text-mx-tertiary">可管理</div>,
    value: RoleType.Manager,
  },
  // {
  //   label: <div className="flex px-2 font-400 color-mx-error ">移除</div>,
  //   value: RoleType.Removed,
  // },
];

interface RoleSelectProps {
  roleType: string;
  disabled?: boolean;
  showList?: RoleType[];
  setRoleType: (roleType: string) => void;
}

const RoleSelect = ({ roleType, disabled, showList, setRoleType }: RoleSelectProps) => {
  const showPermissionOptions = showList ? permissionOptions.filter(item=> showList.includes(item.value)): permissionOptions;
  return (
    <RSelect
      disabled={disabled}
      options={showPermissionOptions}
      value={roleType}
      placement="topRight"
      title={
        <div className="pl-2 h-6 lh-6 text-3 text-mx-quaternary mb-1">权限</div>
      }
      onChange={(value) => {
        setRoleType(value as string);
      }}
      downIcon={<ArrowDownIcon />}
      upIcon={<ArrowUpIcon />}
      contentStyleWidth="10rem"
    />
  );
};

export default RoleSelect;
